<template>
    <div :style="{opacity:isOpacity}" style="transition: 0.3s">
         <!-- ====== Banner Start ====== -->
         <section class="ch-gw-page-banner product_img" :style="{backgroundImage:'url('+ urls.a1 +')'}" >
      <div class="container">
        <div class="row product_img_row" >
          <img :src="urls.a2" >
        </div>
      </div>
    </section>
    <!-- ====== Banner End ====== -->


    <section class="ch-gw-page-grids" style="background-color: #F0F2F7;" v-if="screenWidth>=992">
      <div class="container">
        <div class="row" style="width: 100%;height: 4rem;display: flex;flex-wrap: nowrap;">
          <a href="javascript:void(0)" @click="plate(index)" style="width: 13rem;height: 100%;" v-for="(item,index) in aboutList">
            <div v-bind:style="{background:plateIndex == index?'linear-gradient(45deg, #298BF1 , #43ddf1)':'linear-gradient(45deg, #F0F2F7 , #F0F2F7)',color: plateIndex == index?'rgb(255,255,255)':'rgb(0, 0, 0)',borderRight: plateIndex == index?'':'1px solid rgba(0, 0, 0, 0.1)'}" style="transition:0.6s;width: 100%;height: 100%;font-size: 1.2rem;font-weight: 700;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;align-items: center;">{{ item.name }}</div>
          </a>
          <!-- <a href="javascript:void(0)" @click="plate(0)" style="width: 13rem;height: 100%;">
            <div v-bind:style="{background:plateIndex == 0?'linear-gradient(45deg, #298BF1 , #43ddf1)':'linear-gradient(45deg, #F0F2F7 , #F0F2F7)',color: plateIndex == 0?'rgb(255,255,255)':'rgb(0, 0, 0)',borderRight: plateIndex == 0?'':'1px solid rgba(0, 0, 0, 0.1)'}" style="transition:0.6s;width: 100%;height: 100%;font-size: 1.2rem;font-weight: 700;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;align-items: center;">企业介绍</div>
          </a>
          <a href="javascript:void(0)" @click="plate(1)" style="width: 13rem;height: 100%;">
            <div v-bind:style="{background:plateIndex == 1?'linear-gradient(45deg, #298BF1 , #43ddf1)':'linear-gradient(45deg, #F0F2F7 , #F0F2F7)',color: plateIndex == 1?'rgb(255,255,255)':'rgb(0, 0, 0)',borderRight: plateIndex == 1?'':'1px solid rgba(0, 0, 0, 0.1)'}" style="transition:0.6s;width: 100%;height: 100%;font-size: 1.2rem;font-weight: 700;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;align-items: center;">发展历程</div>
          </a>
          <a href="javascript:void(0)" @click="plate(2)" style="width: 13rem;height: 100%;">
            <div v-bind:style="{background:plateIndex == 2?'linear-gradient(45deg, #298BF1 , #43ddf1)':'linear-gradient(45deg, #F0F2F7 , #F0F2F7)',color: plateIndex == 2?'rgb(255,255,255)':'rgb(0, 0, 0)',borderRight: plateIndex == 2?'':'1px solid rgba(0, 0, 0, 0.1)'}" style="transition:0.6s;width: 100%;height: 100%;font-size: 1.2rem;font-weight: 700;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;align-items: center;">平台实力</div>
          </a>
          <a href="javascript:void(0)" @click="plate(3)" style="width: 13rem;height: 100%;">
            <div v-bind:style="{background:plateIndex == 3?'linear-gradient(45deg, #298BF1 , #43ddf1)':'linear-gradient(45deg, #F0F2F7 , #F0F2F7)',color: plateIndex == 3?'rgb(255,255,255)':'rgb(0, 0, 0)',borderRight: plateIndex == 3?'':'1px solid rgba(0, 0, 0, 0.1)'}" style="transition:0.6s;width: 100%;height: 100%;font-size: 1.2rem;font-weight: 700;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;align-items: center;">专利荣誉</div>
          </a>
          <a href="javascript:void(0)" @click="plate(4)" style="width: 13rem;height: 100%;">
            <div v-bind:style="{background:plateIndex == 4?'linear-gradient(45deg, #298BF1 , #43ddf1)':'linear-gradient(45deg, #F0F2F7 , #F0F2F7)',color: plateIndex == 4?'rgb(255,255,255)':'rgb(0, 0, 0)',borderRight: plateIndex == 4?'':'1px solid rgba(0, 0, 0, 0.1)'}" style="transition:0.6s;width: 100%;height: 100%;font-size: 1.2rem;font-weight: 700;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;align-items: center;">新闻动态</div> 
          </a>-->
        </div>
      </div>
    </section>

    <section class="ch-gw-page-grids" style="background-color: #F0F2F7;" v-if="screenWidth<=991">
      <div class="container m_container" style="width: 100%;height: 3.5rem;position: relative;;display: flex;align-items: center;justify-content: center;">
          <div  style="margin: 0 auto;">{{ aboutList[aboutName].name }}</div>
          <i class="el-icon-menu" style="font-size: 1.5rem;position: absolute;right: 1rem;"></i>
          <el-select v-model="aboutName" @change="plate(aboutName)" placeholder="请选择" style="position: absolute;width: 10px;right: 3rem;opacity: 0;">
            <el-option
              v-for="item in aboutList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        
      </div>
    </section>

    <introduce v-show="plateIndex == 0"></introduce>
    <development v-show="plateIndex == 1"></development>
    <platform v-show="plateIndex == 2"></platform>
    <patent v-show="plateIndex == 3"></patent>
    <news v-show="plateIndex == 4"></news>
    </div>
</template>

<script>
import introduce from '@/components/about/introduce'
import patent from '@/components/about/patent'
import development from '@/components/about/development'
import news from '@/components/about/news'
import platform from '@/components/about/platform'
export default {
    components: {
        introduce,
        patent,
        development,
        news,
        platform
    },
    name: 'index',
    data() {
        return {
            urls:{
                a1: require('@/assets/ch/cpzx.png'),
                a2: require('@/assets/ch/cpzx-wz.png'),
            },
            plateIndex:0,
            isOpacity:0,
            aboutName:0,
            aboutList:[
              {name:'企业介绍',
                value:0
              },
              {name:'发展历程',
                value:1
              }
              ,
              {name:'平台实力',
                value:2
              }
              ,
              {name:'专利荣誉',
                value:3
              }
              ,
              {name:'新闻动态',
                value:4
              }
            ]
        }
    },
    props:['screenWidth'],
    mounted() {
      var that = this
      that.plateIndex = that.getQueryString("fatherUrl")
      var i = setTimeout(function(){
        that.isOpacity = 1
        clearTimeout(i)
      },200)
    },
    methods: {
        plate(i){

            var that = this
            that.plateIndex = i
            //document.documentElement.scrollTop = 0;
        },
        getQueryString(name) {
          var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
          var r = window.location.search.substr(1).match(reg);
          if (r != null) {
              return decodeURI(r[2]);
          }
          return 0;
      }
    }
}
</script>
<style  scoped>

</style>



// WEBPACK FOOTER //
// src/components/about.vue